<div class="game-dashboard-block class-main-statistics-block" brtBorderGradient [color]="'blue'">
  <div class="class-main-statistics-block__header">
    <brt-dashboard-boxes-head [data]="headlineComponentData"></brt-dashboard-boxes-head>
  </div>

  <div class="class-main-statistics-block__content">


    <div class="class-main-statistics-block__column">
      <div class="class-main-statistics-block__column-title">
          <brt-icon [icon]="'raking'" [add-blur]="true"></brt-icon><span>{{ "TEACHER_DASHBOARD.PLACEMENT" | translate }}</span>
      </div>
      <div class="class-main-statistics-block__ranking-data" *ngIf="rankingData">
          <div *ngIf="currentExperience > 0">
            <div class="class-main-statistics-block__ranking-place">{{rankingData.position}}.&nbsp;</div>
            <div class="class-main-statistics-block__ranking-label">{{"TEACHER_DASHBOARD.POSITION" | translate}}</div>
          </div>
        <div class="class-main-statistics-block__ranking-difference" *ngIf="rankingData.difference !== 'NONE'">
            <brt-icon [icon]="rankingData.difference === 'NEGATIVE' ? 'dropdown' : 'dropup'"></brt-icon>
        </div>
        <div class="class-main-statistics-block__ranking-line-chart" *ngIf="chartData">
            <brt-chart [data]="chartData"></brt-chart>
        </div>
      </div>
      <div class="class-main-statistics-block__ranking-data" *ngIf="rankingData == null">
          <div class="class-main-statistics-block__experience-label">Noch keine Punkte gesammelt</div>
      </div>
      <div class="class-main-statistics-block__column-footer">
          <span class="animline animline--white" (click)="openRankingList()">{{"TEACHER_DASHBOARD.RANKING" | translate}}</span>
      </div>
    </div>
    <div class="class-main-statistics-block__column">
      <div class="class-main-statistics-block__column-title">
          <brt-icon [icon]="'location-flag'" [add-blur]="true"></brt-icon>
          <span>{{"TEACHER_DASHBOARD.POINTS" | translate}}</span>
      </div>

      <ng-container *ngIf="currentExperience != -1; else emptyExperienceBlock">
        <div class="class-main-statistics-block__experience-data">
          <div class="class-main-statistics-block__experience-value">{{currentExperience | number:'.'}}</div>
          <div class="class-main-statistics-block__experience-label">{{milestonesLabelString}}</div>
          <div class="class-main-statistics-block__experience-milestones">
            <div class="class-main-statistics-block__experience-milestone-icon" *ngFor="let milestone of achievedMilestones.slice(0, maxMilestoneIconsNumberToShow)">
              <img [src]="'/assets/game-dashboard-icons/milestones/' + milestone.iconName" [alt]="milestone.name">
            </div>

            <div class="class-main-statistics-block__experience-milestone-more" *ngIf="maxMilestoneIconsNumberToShow < achievedMilestones.length">
              +{{achievedMilestones.length - maxMilestoneIconsNumberToShow}}
            </div>
          </div>
        </div>
      </ng-container>


      <ng-template #emptyExperienceBlock>
        <div class="class-main-statistics-block__experience-data">
          <div class="class-main-statistics-block__experience-value">0</div>
          <div class="class-main-statistics-block__experience-label">0 von 12 Meilensteine</div>
          <div class="class-main-statistics-block__experience-milestones"></div>
        </div>
      </ng-template>

      <div class="class-main-statistics-block__column-footer" (click)="openMilestonesOverlay()"><span class="animline animline--white">{{"TEACHER_DASHBOARD.SHOW_ALL_POINTS" | translate}}</span></div>
    </div>
    <div class="class-main-statistics-block__column">
      <div class="class-main-statistics-block__column-title"><brt-icon [icon]="'trophy'" [add-blur]="true"></brt-icon><span>{{"TEACHER_DASHBOARD.TROPHIES" | translate}}</span></div>

      <div class="class-main-statistics-block__trophy-data" *ngIf="trophyData">
        <div class="class-main-statistics-block__trophy-data-headline">
          <div class="class-main-statistics-block__trophy-value">{{currentTrophyProgress}}%</div>
          <div class="class-main-statistics-block__trophy-data-headline-right">
            <div class="class-main-statistics-block__trophy-progress-bar">
              <div class="class-main-statistics-block__trophy-progress-bar-fill" [ngStyle]="{width: currentTrophyProgress + '%'}"></div>
            </div>

            <div class="class-main-statistics-block__trophy-label">{{completedTrophyItems.length}} von {{totalTrophyNumber}} gesammelt</div>
          </div>
        </div>

        <div class="class-main-statistics-block__trophy-icons">
          <div class="class-main-statistics-block__trophy-icon" *ngFor="let trophy of completedTrophiesData.slice(0, maxTrophyIconsNumberToShow)" brtTooltip [text]="trophy.name">
            <brt-trophy-icon [trophy]="trophy" [completed]="true"></brt-trophy-icon>
          </div>

          <div class="class-main-statistics-block__experience-milestone-more" *ngIf="maxTrophyIconsNumberToShow < completedTrophyItems.length">
            +{{completedTrophyItems.length - maxTrophyIconsNumberToShow}}
          </div>
        </div>
      </div>

      <div class="class-main-statistics-block__column-footer">
        <span class="animline animline--white" (click)="showTrophiesOverlay()" >{{"TEACHER_DASHBOARD.SHOW_ALL_TROPHIES" | translate}}</span>
      </div>
    </div>
<!--    <div class="class-main-statistics-block__column">-->
<!--      <div class="class-main-statistics-block__column-title"><brt-icon [icon]="'time'" [add-blur]="true"></brt-icon><span>{{"TEACHER_DASHBOARD.PLAYTIME" | translate}}</span></div>-->

<!--      <div class="class-main-statistics-block__played-time-data">-->
<!--        <div class="class-main-statistics-block__played-time-label">{{ playTimeString }}</div>-->
<!--        <div class="class-main-statistics-block__played-time-difference positive" *ngIf="true" [ngClass]="[(true) ? 'positive' : 'negative']">-->
<!--          <span class="class-main-statistics-block__item-value-difference-arrow-up">↑</span><span class="class-main-statistics-block__item-value-difference-arrow-down">↓</span> {{"TEACHER_DASHBOARD.PLAYTIME_PERCENT" | translate }}-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->


  </div>

</div>
